import React, { useEffect, useRef, useState } from "react";
import { get_media_url } from "../../api/utils";
import { CiPause1, CiPlay1 } from "react-icons/ci";

export const FullVideoCard = ({ content }) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const togglePlayPause = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) videoRef.current.play();
      else videoRef.current.pause();
    }
  };

  const handleWaiting = (value) => {
    setIsLoading(value);
  };

  useEffect(() => {
    const videoEle = videoRef.current;

    if (videoEle) {
      const handlePlayPauseEvent = () => setIsPlaying(!videoEle.paused);
      videoEle.addEventListener("play", handlePlayPauseEvent);
      videoEle.addEventListener("pause", handlePlayPauseEvent);

      return () => {
        videoEle.removeEventListener("play", handlePlayPauseEvent);
        videoEle.removeEventListener("pause", handlePlayPauseEvent);
      };
    }
  }, [videoRef]);

  return (
    <div className="w-full h-full relative bg-[#2C2D36 group">
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center z-10">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-white"></div>
        </div>
      )}
      <video
        ref={videoRef}
        className="w-full h-full object-cover"
        src={get_media_url(content.foreground_video)}
        onLoadedData={() => handleWaiting(false)}
        onWaiting={() => handleWaiting(true)}
        onLoadStart={() => handleWaiting(true)}
        onCanPlay={() => handleWaiting(false)}
        onClick={togglePlayPause}
        autoPlay
      />
      <div className="absolute top-3 right-3 flex justify-center space-x-4 z-20 opacity-50 group-hover:opacity-100 transition-opacity duration-200">
        <button
          onClick={togglePlayPause}
          className="bg-[#2C2D36] rounded-full w-10 h-10 flex items-center justify-center hover:bg-[#272830] transition-colors"
        >
          {isPlaying ? <CiPause1 /> : <CiPlay1 className="ml-[1px]" />}
        </button>
      </div>
    </div>
  );
};
